
import clientApiManager from '../clientApiManager'

export function curatedListService(storefrontApiClient = clientApiManager) {
  return storefrontApiClient.get(`/curatedflex/${window.curatedFlexId}`);
}



// WEBPACK FOOTER //
// ./src/service/curatedlist/curatedListService.js